import { getStorage } from "./tools"

// isDebug 模式
export const isDebugMode = () => {
    return localStorage.getItem("isDebug") === 'true'
}

// setStorages({ isDefaultEpid: res.isDefaultEpid, isSuperAdmin: res.isSuperAdmin })
// 是否是默认企业
export const isDefaultEpid = () => {
    return getStorage('isDefaultEpid') === 'true'
}

// 是否是超管
export const isSuperAdmin = () => {
    return getStorage('isSuperAdmin') === 'true'
}

//   是否用于最高权限
export const isHighAuth = () => {
    return isDebugMode() || (isDefaultEpid() && isSuperAdmin())
}